import React from "react";
import styled from 'react-emotion'
import Helmet from 'react-helmet'

import Section from '../components/section/Section'
import HeroImage from '../components/HeroImage'
import CategoryList from '../templates/category-list';
import Link from 'gatsby-link'
import { blogFormat, createLink, addComma } from '../utils/whistle.js'

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

const Container = styled.div`
`

const Header = styled.h1`
  text-align: left;
  font-size: 2rem;
  line-height: 2.2rem;
`

const BlogList = styled.div`
  flex: 1;
  flex-direction: column;
  padding: 1rem;
  h1 {
    text-align: left;
  }
  h3 {
    text-align: right;
  }
  a.tag {
    padding: 4px 10px;
    background-color: #00B386;
    color: white;
    margin: 2px;
    font-size: 0.9rem;
  }
  .blog-content {
    p img {
      max-width: 100%;
      margin: 0 auto;
      display: block;
      padding: 1rem 0;
    }
    @media (max-width: 800px) {
      p img {
        width: 100%;
      }
    }
  }
`

const Row = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 1rem;
  @media (min-width: 800px) {
		flex-direction: row;
  }
`

const Column = styled.div`
  display: flex;
  flex: 0.75;
  flex-flow: wrap;
`
const EndColumn = styled.div`
  display: flex;
  flex: 0.25;
  flex-direction: row;
  justify-content: flex-start;
  @media (min-width: 800px) {
    align-self: center;
    justify-content: flex-end;
  }
`


const Back = styled.div`
  border-top: 1px solid #F8F8F8;
  padding: 1rem 0;
`

const prettyCategories = (arr) => {
  return arr.map((category, i) => {
    return (
      <Link className="tag" to={`/news/${createLink(category)}/`}>
        {category}
      </Link>
    )
  })
}

export default function Template( props ) {
  const data = blogFormat(props.data)
  const { markdownRemark } = props.data; // data.markdownRemark holds our post data
  const { frontmatter } = markdownRemark;

  return (
    <Section>
      <Helmet
        title={frontmatter.title}
        meta={[
          { name: 'og:title', content: frontmatter.title },
          { name: 'description', content: frontmatter.description },
          { name: 'og:description', content: frontmatter.description },
          { name: 'og:image', content: frontmatter.hero ? `https://trywhistle.com/${frontmatter.hero}` : '' },
          { name: 'og:type', content: "article" },
          { name: 'og:locale', content: "en_US" },
          { name: 'article:tag', content: frontmatter.categories },
        ]}
      />
      <Wrapper>
        {frontmatter.hero ? (
          <HeroImage
            alt={frontmatter.title}
            src={frontmatter.hero}
          />
        ) : (null)}
        <Container>
          {/* <CategoryList categories={data.allCategories} /> */}
          <BlogList>
            <Header>{data.title}</Header>
            <i>{data.author}</i>
            <Row>
              <Column>
                {prettyCategories(data.categories)}
              </Column>
              <EndColumn>
                <h3>{data.date}</h3>
              </EndColumn>
            </Row>
            <div className="blog-content" dangerouslySetInnerHTML={{ __html: data.html }}></div>
            <Back>
              <Link to="/news" >Back to list</Link>
            </Back>
          </BlogList>
        </Container>
      </Wrapper>
    </Section>
  );
}

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        hero
        description
        categories
      }
    }
    categories: allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___categories) {
        fieldValue
        totalCount
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/news-post.js